import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";

// IMAGES
import PLACEHOLDER from "../../assets/images/hostel.jpg";
import { TitleB } from "../common/title/Title.common";

const TraineesHostelPage = () => {
  const { setHeaderTitle } = useAuth();

  useEffect(() => {
    setHeaderTitle("Trainee's Hostel");
  }, [setHeaderTitle]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <CompWrapper>
      <div>
        <div className="mb-5">
          <TitleB title="Trainee's Hostel" />
          <p>
            A well furnished 37 bed trainees hostel is available. Trainees
            hostel has facility for training, canteen etc.
          </p>
        </div>
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
        <div className="mt-5">
          <TitleB title="Contact Persons:" />
          <p>Dr. Govinda Prasad Timsina, Station Chief, ARS, Pakhribas</p>
          <p className="mt-3">
            <b className="text-bold">E-mail:</b>  arspakh@gmail.com
          </p>
          <p className="mt-3">
            <b className="text-bold">Tel.:</b> (+977) 026-405111/ 9802726581
          </p>
          <p className="mt-5">
            Lal Bahadur Magar, Administrative Officer, ARS, Pakhribas
          </p>
          <p className="mt-3">
            <b className="text-bold">Tel.:</b> (+977) 026-405111/ 9807349562
          </p>
          <p className="mt-5">
            Prem Dahal, Administrative Assistant/ Trainee&#39;s Hostel Incharge,
            ARS Pakhribas
          </p>
          <p className="mt-3">
            <b className="text-bold">Tel.:</b> 9807014488/ 9819074119
          </p>
        </div>
      </div>
    </CompWrapper>
  );
};

export default TraineesHostelPage;
